<template>
    <div class="information-client">
        <div class="information-client__title">
            <slot name="title"></slot>
        </div>
        <div class="information-client__text">
            <slot name="text"></slot>
        </div>
        <div class="information-client__action">
            <STBaseButton :text="buttonText"
                          @click="$emit('close')" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'InformationClient',

    props: {
        buttonText: String,
    }
};
</script>

<style lang="scss">
@import "./InformationClient.scss";
</style>
